import { render, staticRenderFns } from "./RegionFreightSelect.vue?vue&type=template&id=325c08eb&"
import script from "./RegionFreightSelect.vue?vue&type=script&lang=js&"
export * from "./RegionFreightSelect.vue?vue&type=script&lang=js&"
import style0 from "./RegionFreightSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports